import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import styled from "styled-components";
import { NOTIFY } from "../based/Constants";
import { Notify } from "../based/Notify";
import CommonModal from "../based/refactor/CommonModal";
import FinanceServices from "../based/services/FinanceServices";
import LogoRanus from "./assets/LogoRanus.png";
import MBBank from "./assets/MBBank.png";
import Common from "../based/Common";

function DepositModal({ show, onClose, id }) {
    const [showQR, setShowQR] = useState(true);
    const [model, setModel] = useState({ amount: 0 });

    useEffect(() => {
        if (id) {
            getWalletHistory(id);
        }
    }, [id]);

    const createTopupQr = async (model) => {
        const [err, data] = await FinanceServices.CreateWalletHistory(model);
        if (!err && data) {
            setModel(data);
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Không thể tạo mã nạp tiền. Vui lòng thử lại sau.");
        }
    };

    const getWalletHistory = async (id) => {
        const [err, data] = await FinanceServices.GetWalletHistory(id);
        if (!err && data) {
            setModel(data);
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Không thể lấy lịch sử ví. Vui lòng thử lại sau.");
        }
    };

    return (
        <CommonModal
            show={show}
            onClose={onClose}
            title="Nạp tiền"
            size="md"
            customButton={
                <button
                    onClick={() => {
                        if (model && model.qrString) {
                            setModel({ amount: 0 });
                        } else {
                            createTopupQr(model);
                        }
                    }}
                    className="btn btn-topup"
                >
                    {model && model.qrString ? "Đổi mã khác" : "Tạo mã nạp"}
                </button>
            }
        >
            <Wrapper>
                {model && model.qrString ? (
                    <div class="deposit-modal">
                        <div class="deposit-modal__title">Quét mã QR bằng App ngân hàng để nạp</div>
                        <div class="deposit-modal__card">
                            <div class="deposit-modal__bank-header">
                                <img src={LogoRanus} alt="RANUS" class="deposit-modal__logo" />
                                <span class="deposit-modal__divider">|</span>
                                <img src={MBBank} alt="Vietcombank" class="deposit-modal__logo" />
                            </div>
                            <div class="deposit-modal__qr">
                                <QRCode value={model?.qrString} />
                            </div>
                            <div class="deposit-modal__account">
                                <div class="deposit-modal__account-name">CÔNG TY TNHH RANUS-TECH</div>
                                <div class="deposit-modal__account-number">
                                    {model?.accountId}
                                    <button
                                        class="deposit-modal__copy"
                                        title="Copy account number"
                                        onClick={(e) => {
                                            navigator.clipboard.writeText(model?.accountId);
                                            Notify(NOTIFY.INFO, "Thông báo", "Sao chép thành công");
                                        }}
                                    >
                                        <i className="fa fa-copy"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="deposit-modal__info-row">
                                <span class="deposit-modal__info-label">Số tiền</span>
                                <span class="deposit-modal__info-value">{Common.formatCurrency(model?.amount)}</span>
                                <button
                                    class="deposit-modal__copy"
                                    title="Copy amount"
                                    onClick={(e) => {
                                        navigator.clipboard.writeText(model?.amount);
                                        Notify(NOTIFY.INFO, "Thông báo", "Sao chép thành công");
                                    }}
                                >
                                    <i className="fa fa-copy"></i>
                                </button>
                            </div>
                            <div class="deposit-modal__info-row">
                                <span class="deposit-modal__info-label">Nội dung</span>
                                <span class="deposit-modal__info-value">{model?.content}</span>
                                <button
                                    class="deposit-modal__copy"
                                    title="Copy content"
                                    onClick={(e) => {
                                        navigator.clipboard.writeText(model?.content);
                                        Notify(NOTIFY.INFO, "Thông báo", "Sao chép thành công");
                                    }}
                                >
                                    <i className="fa fa-copy"></i>
                                </button>
                            </div>
                        </div>
                        <div class="deposit-modal__note">Hiệu lực 120 phút kể từ lúc xuất mã</div>
                    </div>
                ) : (
                    <div class="withdraw-form">
                        <div class="withdraw-form__group">
                            <label class="withdraw-form__label" for="withdraw-amount">
                                Nhập số tiền muốn nạp <span class="withdraw-form__required">*</span>
                            </label>
                            <div className="sub-main">Tối thiểu 200.000đ</div>
                            <div class="withdraw-form__amount-input">
                                <input
                                    id="withdraw-amount"
                                    class="withdraw-form__input"
                                    type="number"
                                    placeholder="Nhập số tiền"
                                    inputmode="numeric"
                                    value={model.amount}
                                    onChange={(e) => {
                                        setModel({ ...model, amount: +e.target.value });
                                    }}
                                    min={200000}
                                />
                                <span class="withdraw-form__currency">đ</span>
                            </div>
                        </div>
                    </div>
                )}
            </Wrapper>
        </CommonModal>
    );
}

export default DepositModal;

const Wrapper = styled.div`
    .deposit-modal__title {
        text-align: center;
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .deposit-modal__card {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        margin: 12px 0;
        overflow: hidden;
        margin: 12px 52px;
    }

    .deposit-modal__info-row {
        padding: 12px 20px;
        display: flex;
        border: 1px solid #e5e5e5;
    }

    span.deposit-modal__info-value {
        margin-left: auto;
        color: #303030;
        text-align: right;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    button.deposit-modal__copy {
        border: none;
        background: none;
        margin-left: 4px;
    }

    .deposit-modal__qr {
        text-align: center;
        margin: 4px 0;
    }

    .deposit-modal__bank-header {
        text-align: center;
        padding: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    span.deposit-modal__divider {
        padding: 0 18px;
    }

    .deposit-modal__account {
        text-align: center;
        margin: 12px 0;
    }

    .deposit-modal__account-name {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .deposit-modal__account-number {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    button.deposit-modal__copy {
        font-size: 16px;
    }

    .deposit-modal__note {
        color: #ff9027;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .withdraw-form__group {
        display: flex;
        flex-wrap: wrap;
    }

    .sub-main {
        margin-left: auto;
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .withdraw-form__amount-input {
        width: 100%;
        margin: 12px 0;
    }

    label.withdraw-form__label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .withdraw-form__wallet-select {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        overflow: hidden;
    }

    .withdraw-form__select div {
        border: none;
    }

    .withdraw-form__select div {
        border-radius: 8px 8px 0 0;
        background: #f8f8f8;
    }

    .withdraw-form__wallet-info {
        padding: 12px;
    }

    .withdraw-form__wallet-balance {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        align-items: center;
    }

    .withdraw-form__wallet-details {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
    }

    .withdraw-form__wallet-balance strong {
        color: #303030;
        margin-left: 12px;
        font-weight: 600;
    }

    .withdraw-form__group {
        margin: 12px 0;
    }

    .withdraw-form__amount-input {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        display: flex;
        align-items: center;
    }

    .withdraw-form__amount-input input {
        border: none;
        width: 100%;
        padding: 0 20px;
    }

    span.withdraw-form__currency {
        flex: 1;
        padding: 20px;
        background: #f3f3f3;
    }

    .withdraw-form__max-note {
        margin: 12px 0;
        color: #ff9027;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;
